var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"wind-simple-table__column",style:(_vm.columnStyle)},[_c('div',{staticClass:"wind-simple-table__th"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }